export default __webpack_public_path__ + "static/media/standsExpo_humbrall.1fbb9f11.jpg";